import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TaskStatusEnum} from "../../../../../domain/enums/task-status.enum";
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {TaskModel} from "../../../../../domain/models/task.model";
import {TaskService} from "../../../../../domain/services/task/task.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-task-action-bar',
  standalone: true,
  imports: [
    MatButton,
    MatIcon,
    MatProgressSpinnerModule
  ],
  templateUrl: './task-action-bar.component.html',
  styleUrl: './task-action-bar.component.css'
})
export class TaskActionBarComponent {
  @Input() currentTask!: TaskModel;
  @Input() recentlyLocked: boolean = false;
  @Input() disabled: boolean = false;
  /** Blocks only Approve (e.g. an unresolved possible-duplicate property). */
  @Input() approveDisabled = false;
  @Output() isTaskApproved = new EventEmitter<boolean>();
  /** Parent handles the save; the bar only shows the button when someone listens. */
  @Output() save = new EventEmitter<void>();
  @Input() saving = false;
  protected readonly TaskStatusEnum = TaskStatusEnum;
  isLoading = false;

  constructor(private readonly taskService: TaskService,
              private readonly router: Router) {
  }

  onDiscartAndExit() {
    if (this.recentlyLocked) {
      this.currentTask.status = TaskStatusEnum.OPEN;
      this.taskService.update(this.currentTask.id, this.currentTask).subscribe(value => {
        this.currentTask = value;
        this.recentlyLocked = false;
        this.exit();
      });
    } else {
      this.exit();
    }
  }

  approve() {
    this.isLoading = true;
    this.isTaskApproved.emit(true);
  }

  decline() {
    this.isLoading = true;
    this.isTaskApproved.emit(false);
  }

  /** A declined task can be put back in the queue for another review. Approved tasks can't be
   *  reopened: approval already created the account/property — deactivate those instead. */
  reopen() {
    this.isLoading = true;
    this.currentTask.status = TaskStatusEnum.OPEN;
    this.taskService.update(this.currentTask.id, this.currentTask).subscribe({
      next: value => { this.currentTask.status = value.status; this.isLoading = false; },
      error: () => { this.currentTask.status = TaskStatusEnum.DECLINED; this.isLoading = false; }
    });
  }

  resetLoading() {
    this.isLoading = false;
  }

  private exit() {
    this.router.navigate(["/app/tasks"]);
  }
}
